export default {
  state: {
    timeoutNoty: 2000
  },
  mutations: {},
  actions: {},
  getters: {
    getTimeoutNoty(state) {
      return state.timeoutNoty;
    },
  }
}